import React from 'react';
import Grid from '@mui/material/Grid2';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@mui/styles';
import BreadCrumbs from "../../../components/elements/BreadCrumbs";
import AppAnimate from "../../../components/AppAnimate";
import AppCard from "../../../components/layout/components/AppCard";
import MakeProduct from "./MakeProduct";
import {useTranslation} from "react-i18next";
import Title from "../../../components/elements/Title";
import {isAdmin} from "../../../../config/Permissions";
import {ArrowLeft, ChevronLeft} from "lucide-react";
import {useNavigate} from "react-router-dom";
import {IconButton} from "@mui/material";
import BulkEditProducts from "./BulkEditProducts";



function BulkEditProductsPage({create}){
    const { t } = useTranslation();
    const navigation = useNavigate();

    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={t('bulkEditProducts')}>
            <Grid container spacing={2} justify="center">
                <Grid item size={12} >
                    <Title align="left" color="text" className="mb-0 title-app">{t('bulkEditProducts')}</Title>
                    <BulkEditProducts/>
                </Grid>
            </Grid>
        </AppAnimate>
    );
}
export default withStyles(Styles)(BulkEditProductsPage);
